import { FC } from 'react'

import DialogWindow from '@/components/DialogWindow'
import { Typography } from '@/components/ui'

import Cancel from '@/assets/icons/cancel-3.svg'
import Check from '@/assets/icons/check.svg'

interface IHighlightOverlapDialog {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

const HighlightOverlapDialog: FC<IHighlightOverlapDialog> = ({
	open,
	onClose,
	onConfirm
}) => {
	return (
		<DialogWindow
			open={open}
			onClose={onClose}
			handleClick={onConfirm}
			titleText='Highlight Overlap'
			body={
				<Typography variant='text' className='text-black text-[16px]'>
					You have an overlap! If you don't change the highlight selection, then
					the video will have a doubled section! Do you want to continue?
				</Typography>
			}
			yesButtonText={
				<>
					<Check />
					<span>Yes, continue</span>
				</>
			}
			noButtonText={
				<>
					<Cancel className='w-3 h-3' />
					<span>Cancel</span>
				</>
			}
			noButtonClassname='hover:bg-neutral-200'
			yesButtonClassname='hover:bg-neutral-700'
			noButtonClassnameText='flex items-center gap-3'
			yesButtonClassnameText='flex items-center gap-3'
			closeOnEscape={false}
			closeOnInteractOutside={false}
		/>
	)
}

export default HighlightOverlapDialog
